export default __webpack_public_path__ + "static/media/raiyan-chowdhury-cv-mk9x.c03fccd8.pdf";